import { useGetMultiSiteState } from 'App/actions/api/multisite';
import GroupIcon from '@mui/icons-material/Domain';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSite from '../MultiSite';

const Footer = ({ user, setActiveRole, activeRole }) => {
  const [selectOrgAnchor, setSelectOrgAnchor] = useState(null);

  const { data: multiSiteState } = useGetMultiSiteState();
  const multiSiteColor = useMemo(() => {
    if (multiSiteState?.mode === 'Multi') {
      return multiSiteState?.state === 'Active' ? 'success.main' : 'warning.main';
    }
    return undefined;
  }, [multiSiteState]);
  const closeSelectOrg = useCallback(() => {
    setSelectOrgAnchor(null);
  }, []);
  const openSelectOrg = useCallback(e => {
    setSelectOrgAnchor(e.currentTarget);
  }, []);
  const setActiveRoleCallback = useCallback(
    role => {
      setActiveRole(role);
      closeSelectOrg();
    },
    [setActiveRole, closeSelectOrg]
  );
  return (
    <AppBar
      component="div"
      position="fixed"
      sx={{
        p: 0,
        borderTop: `${multiSiteColor ? '3px' : '1px'} solid`,
        borderColor: multiSiteColor || 'borders.moderate',
        top: 'auto',
        left: 0,
        bottom: 0,
        bgcolor: 'surface.7',
        zIndex: 2000,
      }}
    >
      <Box sx={{ height: 40, display: 'flex', alignItems: 'center', ml: 2 }}>
        <MultiSite multiSiteState={multiSiteState} />
        <GroupIcon />
        <Typography sx={{ ml: 1 }}>
          <FormattedMessage id="sharedComponents-Footer-organization" defaultMessage="Organization:" />
        </Typography>
        {user?.roles && (
          <>
            <Menu anchorEl={selectOrgAnchor} open={!!selectOrgAnchor} onClose={closeSelectOrg}>
              {user.roles.map(item =>
                item.organizationDetails ? (
                  <MenuItem key={item.organizationId} onClick={() => setActiveRoleCallback(item)}>
                    {item.organizationDetails.name}
                  </MenuItem>
                ) : null
              )}
            </Menu>
            <Button
              color="inherit"
              disabled={user.roles.length === 1}
              onClick={openSelectOrg}
              sx={{ py: 1, px: '13px', overflow: 'hidden', ml: 1, pt: 0, pb: 0 }}
            >
              {activeRole?.organizationDetails?.name}
            </Button>
          </>
        )}
        <Box sx={{ flexGrow: 1 }} />
      </Box>
    </AppBar>
  );
};

export default Footer;
